import React from "react";
import styled from "styled-components";
import { BookingHeader } from ".";
import Box from "../../../components/Box";
import { Loading } from "../../../config/StyledComponents";
import HeaderText from "./HeaderText";

const MobileViewLayout = ({ bookingList, handleClick, isTableDataLoading }) => {
  return (
    <MobileContainer>
      {!isTableDataLoading ? (
        bookingList.map((eachList, idx1) => {
          return (
            <Box boxBorder="0rem" key={idx1}>
              <OuterBox onClick={() => handleClick(eachList.id)}>
                {BookingHeader.map((eachHeader, idx2) => {
                  return (
                    <InnerBox key={idx2}>
                      <HeaderText label={eachHeader.label} />
                      <div>{eachHeader.content(eachList)}</div>
                    </InnerBox>
                  );
                })}
              </OuterBox>
            </Box>
          );
        })
      ) : (
        <Loading>Loading...</Loading>
      )}
    </MobileContainer>
  );
};

export default MobileViewLayout;

const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  > div:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
  }
  > div:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }
`;
const OuterBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  row-gap: 2rem;
  column-gap: 1rem;
  padding: 2rem;
  cursor: pointer;
`;
const InnerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
